(ns frontend.view.modals.entity.create-attributes
  (:require
   [clojure.set :as set]
   [common.util :as cu]
   [frontend.state.permissions :as f-permissions]
   [frontend.tenant-customizations :as tenant-customizations]
   [frontend.view.modals.entity.attributes :as attributes]
   [frontend.view.modals.entity.events :as events]))

(defmulti entity-create-attributes
          (fn [{:keys [entity-type]}]
            entity-type))

(defmethod entity-create-attributes :default
  [{:keys [schema mandatory-fields]}]
  (->> (set/union (->> schema
                       (remove (fn [[_ fs]]
                                 (= :create.visibility/optional (:field/create-visibility fs))))
                       (keys)
                       (set))
                  (set mandatory-fields))
       (into [])
       (sort-by (partial events/sort-by-mandatory-field-first mandatory-fields))))

(defmethod entity-create-attributes :entity.type/survey-template
  [{:keys [schema mandatory-fields]}]
  (->> (set/union (->> schema
                       (remove (fn [[_ fs]]
                                 (= :create.visibility/optional (:field/create-visibility fs))))
                       (cu/remove-by first :survey-template/template-blocks)
                       (keys)
                       (set))
                  (set mandatory-fields))
       (into [])
       (sort-by (partial events/sort-by-mandatory-field-first mandatory-fields))))

(defmethod entity-create-attributes :entity.type/insider-group
  [{:keys [schema mandatory-fields]}]
  (->> (set/union (->> schema
                       (remove (fn [[_ fs]]
                                 (= :create.visibility/optional (:field/create-visibility fs))))
                       (cu/remove-by first :insider-group/status)
                       (keys)
                       (set))
                  (set mandatory-fields))
       (into [])
       (sort-by (partial events/sort-by-mandatory-field-first mandatory-fields))))

(defmethod entity-create-attributes :entity.type/metabase-dashboard
  [_]
  [])

(defmethod entity-create-attributes :entity.type/fund
  [{:keys [mandatory-fields]}]
  (->> (set/union (set attributes/fund-create-attributes) (set mandatory-fields))
       (into [])
       (sort-by (partial events/sort-by-mandatory-field-first mandatory-fields))))

(defmethod entity-create-attributes :entity.type/investor
  [{:keys [mandatory-fields]}]
  (->> (set/union (set attributes/investor-create-attributes)
                  (set mandatory-fields)
                  (when (tenant-customizations/tesi?)
                    (set attributes/tesi-investor-attrs)))
       (into [])
       (sort-by (partial events/sort-by-mandatory-field-first mandatory-fields))))

(defmethod entity-create-attributes :entity.type/pipeline
  [{:keys [mandatory-fields]}]
  (->> (set/union (set attributes/pipeline-create-attributes)
                  (set mandatory-fields))
       (into [])
       (sort-by (partial events/sort-by-mandatory-field-first mandatory-fields))))

(defmethod entity-create-attributes :entity.type/real-estate
  [{:keys [mandatory-fields capman-re?]}]
  (->> (set/union
        (disj (set attributes/real-estate-create-attributes)
              (when capman-re?
                :real-estate/usage))
        (set mandatory-fields))
       (into [])
       (sort-by (partial events/sort-by-mandatory-field-first mandatory-fields))))

(defmethod entity-create-attributes :entity.type/webentry
  [_]
  attributes/webentry-attributes)

(defmethod entity-create-attributes :entity.type/named-value
  [_]
  attributes/named-value-attributes)

(defmethod entity-create-attributes :entity.type/team
  [_]
  [:team/name])

(defmethod entity-create-attributes :entity.type/stage
  [_]
  attributes/stage-attributes)

(defmethod entity-create-attributes :entity.type/opportunity-stage
  [_]
  attributes/opportunity-stage-attributes)

(defmethod entity-create-attributes :entity.type/sales-opportunity-stage
  [_]
  attributes/sales-opportunity-stage-attributes)

(defmethod entity-create-attributes :entity.type/exit-opportunity-stage
  [_]
  attributes/exit-opportunity-stage-attributes)

(defmethod entity-create-attributes :entity.type/fof-asset
  [_]
  attributes/fof-asset-create-attributes)

(defmethod entity-create-attributes :entity.type/company
  [{:keys [mandatory-fields]}]
  (->> (set/union
        (set attributes/company-create-attributes)
        (when (tenant-customizations/diamond-edge-ventures?)
          (set [:asset/country :common/network-drive]))
        (when (tenant-customizations/tesi?)
          (set attributes/tesi-company-attrs))
        (when (tenant-customizations/f-log?)
          (set attributes/f-log-company-attrs))
        (set mandatory-fields))
       (into [])
       (sort-by (partial events/sort-by-mandatory-field-first mandatory-fields))))

(defmethod entity-create-attributes :entity.type/person
  [_]
  (vec
   (concat
    attributes/person-create-attributes
    (when (tenant-customizations/capman?)
      [:person/contact-owner]))))

(defmethod entity-create-attributes :entity.type/holding
  [_]
  (set/union (set attributes/holding-create-attributes)
             (when (tenant-customizations/tesi?)
               (set attributes/tesi-holding-attrs))))

(defmethod entity-create-attributes :entity.type/exit-opportunity
  [{:keys [mandatory-fields]}]
  (->> (set/union (set attributes/exit-oppo-create-attributes) (set mandatory-fields))
       (sort-by (partial events/sort-by-mandatory-field-first mandatory-fields))))

(defmethod entity-create-attributes :entity.type/oppo
  [{:keys [mandatory-fields capman-re? selected-pipeline-id]}]
  (->> (set/union
        (disj (set attributes/oppo-create-attributes)
              (when capman-re?
                :oppo/lead-source-v2)
              (when capman-re?
                :oppo/target-asset))
        (when (tenant-customizations/tesi?)
          (set attributes/tesi-deal-attrs))
        (when (tenant-customizations/diamond-edge-ventures?)
          (set [:oppo/group-companies :oppo/group-business-units]))
        (when (tenant-customizations/f-log?)
          (set attributes/f-log-deal-attrs))
        (when (tenant-customizations/voima-ventures?)
          (set attributes/voima-mandatory-deal-attrs))
        (set mandatory-fields))
       (into [])
       ;; TODO in-use visibility should be taken into account
       ;; probably similar checks should be implemented in other method implementations
       (filter (fn [a]
                 (f-permissions/field-write-access? a :entity.type/oppo selected-pipeline-id)))
       (sort-by (partial events/sort-by-mandatory-field-first mandatory-fields))))

(defmethod entity-create-attributes :entity.type/fund-commitment
  [{:keys [mandatory-fields]}]
  (->> (set/union
        (set attributes/fund-commitment-create-attributes)
        (set mandatory-fields))
       (into [])
       (sort-by (partial events/sort-by-mandatory-field-first mandatory-fields))))
